class SliderCompare extends HTMLElement {
  connectedCallback() {
    this.handle = this.querySelector('.slider-compare__handle');
    this.position = this.clampFromStart();
    this.setPosition(this.position);

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.addEventListener('pointerdown', this.onPointerDown);
    if (this.handle) this.handle.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerdown', this.onPointerDown);
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
  }

  clampFromStart() {
    const start = parseFloat(this.style.getPropertyValue('--slider-start')) || 50;
    return Math.min(100, Math.max(0, start));
  }

  onPointerDown(event) {
    event.preventDefault();
    this.classList.add('is-dragging');
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
    this.updateFromEvent(event);
  }

  onPointerMove(event) {
    this.updateFromEvent(event);
  }

  onPointerUp() {
    this.classList.remove('is-dragging');
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
  }

  onKeyDown(event) {
    const step = event.shiftKey ? 10 : 2;
    if (event.key === 'ArrowLeft') {
      this.setPosition(this.position - step);
      event.preventDefault();
    } else if (event.key === 'ArrowRight') {
      this.setPosition(this.position + step);
      event.preventDefault();
    } else if (event.key === 'Home') {
      this.setPosition(0);
      event.preventDefault();
    } else if (event.key === 'End') {
      this.setPosition(100);
      event.preventDefault();
    }
  }

  updateFromEvent(event) {
    const rect = this.getBoundingClientRect();
    if (!rect.width) return;
    const percent = ((event.clientX - rect.left) / rect.width) * 100;
    this.setPosition(percent);
  }

  setPosition(percent) {
    this.position = Math.min(100, Math.max(0, percent));
    this.style.setProperty('--slider-pos', this.position + '%');
    if (this.handle) {
      this.handle.setAttribute('aria-valuenow', Math.round(this.position));
    }
  }
}

if (!customElements.get('slider-compare')) {
  customElements.define('slider-compare', SliderCompare);
}
